// Zelfde regels als api.synergiejobs.be (src/utils/zod/name.ts): wijzig ze samen, anders geeft de API een 422
// op input die het formulier als geldig toont.
// new RegExp i.p.v. een literal: de tsconfig target (es5) laat de u-flag in literals niet toe.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const personNamePattern = new RegExp("^[\\p{L}\\p{M}\\p{N} '’.-]+$", 'u');
const companyNamePattern = new RegExp("^[\\p{L}\\p{M}\\p{N} '’.,&()/+-]+$", 'u');
const companyNumberPattern = new RegExp('^[\\p{L}\\p{N} .-]*$', 'u');

export const NAME_MAX_LENGTH = 50;

const hasValidLength = (value: string, minLength: number) => {
  const trimmed = value.trim();
  return trimmed.length >= minLength && trimmed.length <= NAME_MAX_LENGTH;
};

export const isValidPersonName = (value: string, minLength = 1) =>
  hasValidLength(value, minLength) && personNamePattern.test(value.trim());

export const isValidCompanyName = (value: string, minLength = 1) =>
  hasValidLength(value, minLength) && companyNamePattern.test(value.trim());

export const isValidCompanyNumber = (value: string) => value.trim().length <= 50 && companyNumberPattern.test(value.trim());
